import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';
import moment from 'moment/moment';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import AddComplaint from './AddComplaint';
import DeleteComplaint from './DeleteComplaint';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

export default function ComplaintDashboard() {
  const navigate = useNavigate();
  const [value, setValue] = React.useState('1');
  const [openAdd, setOpenAdd] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleChange = ( newValue) => {
    setValue(newValue);
  };

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const handleOpenDeleteLead = () => setDeleteDialogOpen(true);
  const handleCloseDeleteLead = () => setDeleteDialogOpen(false);

  //function for fetching property data based on the property id

  // ----------------------------------------------------------------------
  const [complaintData, setComplaintData] = useState([]);
  const params = useParams();
  const complaintId = params.id;
  console.log("in complaint dashboard ", complaintId);
  

  const fetchcomplaintData = async () => {
    try {
      const response = await getApi(`api/complaint/view/${complaintId}`);
      console.log("hyyy =>",response);
      setComplaintData(response?.data?.mergedData);
      
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchcomplaintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, deleteDialogOpen]);

  return (
    <>
      <DeleteComplaint open={deleteDialogOpen} handleClose={handleCloseDeleteLead} />
      <AddComplaint open={openAdd} handleClose={handleCloseAdd} />

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example" textColor="secondary" indicatorColor="secondary">
              <Tab label="Information" value="1" />
            </TabList>

            {/* //-----------buttons-------------------- */}
            <div>
              <Select value="" displayEmpty inputProps={{ 'aria-label': 'Select option' }} sx={{ marginBottom: '12px' }}>
                <MenuItem value="" disabled>
                  Action
                </MenuItem>
                <MenuItem onClick={handleOpenAdd} sx={{ color: '#4CAF50' }}>
                  <AddIcon sx={{ marginRight: 1 }} />
                  Add
                </MenuItem>
                <MenuItem onClick={handleOpenDeleteLead} sx={{ color: '#FF0000' }}>
                  <DeleteIcon sx={{ marginRight: 1 }} />
                  Delete
                </MenuItem>
              </Select>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7' }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </div>
          </Box>
          <TabPanel value="1">
            <Box sx={{ flexGrow: 1, overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  {/* //-------------------- */}
                  <Item sx={{ height: '100%' }}>
                    <Typography variant="h4" fontWeight="bold">
                      Complaint Information
                    </Typography>
                    <hr />
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Complaint Type</Typography>
                        <Typography style={{ color: 'black' }}>{complaintData.type ? complaintData.type : 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Complaint Status :</Typography>
                        <Typography style={{ color: 'black' }}>
                          {complaintData.status === true ? <Box sx={{ color: '#42a142' }}>Resolved</Box> : <Box>Pending</Box>}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ justifyContent: 'between', alignItems: 'center', marginTop: '1px' }}>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Complaint Created On:</Typography>
                        <Typography style={{ color: 'black' }}>
                          {complaintData.createdDate ? moment(complaintData.createdDate).format('YYYY-MM-DD') : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Typography variant="h5">Complaint Description :</Typography>
                        <Typography style={{ color: 'black' }}>{complaintData.description ? complaintData.description : 'N/A'}</Typography>
                      </Grid>
                    </Grid>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </TabContext>
        <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'end', gap: 3 }}>
          <Button startIcon={<DeleteIcon />} variant="outlined" color="error" onClick={handleOpenDeleteLead}>
            Delete
          </Button>
        </Grid>
      </Box>
    </>
  );
}
